// extracted by mini-css-extract-plugin
module.exports = {"activityExplain":"ActivityExplain_activityExplain__3ODtT"};